<script>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { recordCookieAgreeRequest } from "@/api/log";

export default {
  name: "CookiePolicy",
  setup() {

    const store = useStore();
    const showBanner = computed(() => store.getters['cookiePolicy/shouldShow']);
    const user = computed(() => store.getters['auth/getUser']);

    const accept = () => {

      const consentDate = Math.floor((new Date()).getTime() / 1000);

      store.dispatch('cookiePolicy/acceptCookie', {
        datetime: consentDate
      });

      let userId = user.value.id ? user.value.id : null;

      recordCookieAgreeRequest(consentDate, userId);
    }

    onMounted(() => {
      store.dispatch('cookiePolicy/checkCookie');
    });

    return {
      accept,
      showBanner,
      user
    }
  }
}
</script>

<template>
  <div v-if="!user.cookiePolicyConfirm && showBanner" class="policy-cookie">
    <div>
      <div class="text">
        Сайт Наследство.Онлайн обрабатывает cookies с целью персонализации услуги и чтобы было удобнее пользоваться веб-сайтом. Вы можете запретить обработку cookies в настройках браузера. Пожалуйста, ознакомьтесь с <router-link to="/cookie-policy">политикой использования cookies</router-link>. Читайте подробнее, как <router-link to="/policy">Наследство.Онлайн защищает ваши персональные данные</router-link>.
      </div>
      <button type="button" @click="accept">Принять</button>
    </div>
  </div>
</template>

<style scoped>

.policy-cookie {
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: 20px 0;
  z-index: 5;
}

.policy-cookie>div {
  margin: 0 auto;
  background-color: #ebf8ff;
  padding: 15px;
  max-width: 1100px;
  display: flex;
  align-items: center;
  border: 1px solid #CCCCCC;
  -webkit-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  -moz-box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  box-shadow: 4px 4px 8px 0px rgba(34, 60, 80, 0.2);
  border-radius: 5px;
  line-height: 1.5em;
  text-indent: 1em;
}

.policy-cookie>div button {
  background-color: #0F9B15;
  color: #ffffff;
  font-size: 14px;
  border: none;
  display: inline-block;
  padding: 5px;
}

.policy-cookie>div a {
  color: #3194ca;
  text-decoration: underline;
}

.policy-cookie>div a:hover {
  text-decoration: none;
}

</style>
